export { MascotSvg, Confetti } from './celebrationCharacterMotion';
export { useLipSync } from './speakingCharacterMotion';

// celebrating animations
export { default as Nuala1Celebrating } from './nuala_1_celebrating';
export { default as Nuala2Celebrating } from './nuala_2_celebrating';
export { default as Nuala3Celebrating } from './nuala_3_celebrating';
export { default as Nuala4Celebrating } from './nuala_4_celebrating';
export { default as Nuala5Celebrating } from './nuala_5_celebrating';
export { default as Nuala6Celebrating } from './nuala_6_celebrating';
export { default as Nuala7Celebrating } from './nuala_7_celebrating';
export { default as Nuala8Celebrating } from './nuala_8_celebrating';
export { default as Nuala9Celebrating } from './nuala_9_celebrating';
export { default as Nuala10Celebrating } from './nuala_10_celebrating';
export { default as Nuala11Celebrating } from './nuala_11_celebrating';
export { default as Nuala12Celebrating } from './nuala_12_celebrating';
export { default as Nuala13Celebrating } from './nuala_13_celebrating';
export { default as Nuala14Celebrating } from './nuala_14_celebrating';
export { default as Nuala15Celebrating } from './nuala_15_celebrating';
export { default as Nuala16Celebrating } from './nuala_16_celebrating';
export { default as Nuala17Celebrating } from './nuala_17_celebrating';
export { default as Nuala18Celebrating } from './nuala_18_celebrating';
export { default as Nuala19Celebrating } from './nuala_19_celebrating';
export { default as Nuala20Celebrating } from './nuala_20_celebrating';
export { default as Nuala21Celebrating } from './nuala_21_celebrating';

// speaking animations
export { default as Nuala1Speaking } from './nuala_1_speaking';
export { default as Nuala2Speaking } from './nuala_2_speaking';
export { default as Nuala3Speaking } from './nuala_3_speaking';
export { default as Nuala4Speaking } from './nuala_4_speaking';
export { default as Nuala5Speaking } from './nuala_5_speaking';
export { default as Nuala6Speaking } from './nuala_6_speaking';
export { default as Nuala7Speaking } from './nuala_7_speaking';
export { default as Nuala8Speaking } from './nuala_8_speaking';
export { default as Nuala9Speaking } from './nuala_9_speaking';
export { default as Nuala10Speaking } from './nuala_10_speaking';
export { default as Nuala11Speaking } from './nuala_11_speaking';
export { default as Nuala12Speaking } from './nuala_12_speaking';
export { default as Nuala13Speaking } from './nuala_13_speaking';
export { default as Nuala14Speaking } from './nuala_14_speaking';
export { default as Nuala15Speaking } from './nuala_15_speaking';
export { default as Nuala16Speaking } from './nuala_16_speaking';
export { default as Nuala17Speaking } from './nuala_17_speaking';
export { default as Nuala18Speaking } from './nuala_18_speaking';
export { default as Nuala19Speaking } from './nuala_19_speaking';
export { default as Nuala20Speaking } from './nuala_20_speaking';
export { default as Nuala21Speaking } from './nuala_21_speaking';
